import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import { languages } from "../../constants/languages";
import { jsPDF } from "jspdf";
import robotoMedium from "../../constants/jsPdf/Roboto-Medium-normal";
import robotoBold from "../../constants/jsPdf/Roboto-Bold-bold";

class ExportRankingContainer extends Component {
  handleExport = (e) => {
    const showPresent =
      ((this.props.tournament.defaultFields || {})["present"] || {}).show ||
      this.props.tournament.requireCheckIn ||
      false;
    const teamNameX = showPresent ? 45 : 25;

    var doc = new jsPDF();
    let pointsX = this.props.useSets ? 100 : 145;
    let finalPositionX = this.props.useSets ? 62 : 80;
    if (showPresent) {
      finalPositionX = this.props.useSets ? 70 : 88;
    }
    let maxTextLength = this.props.useSets ? 16 : 25;
    doc.addFileToVFS("Roboto-Medium-normal.ttf", robotoMedium);
    doc.addFont("Roboto-Medium-normal.ttf", "Roboto-Medium", "normal");
    doc.addFileToVFS("Roboto-Bold-bold.ttf", robotoBold);
    doc.addFont("Roboto-Bold-bold.ttf", "Roboto-Bold", "bold");
    doc.setFont("Roboto-Medium", "normal", "normal");

    Object.keys(this.props.ranking).forEach((key, i) => {
      if (i !== 0) {
        doc.addPage();
      }
      let extraY = 0;
      if (Object.keys(this.props.ranking).length > 1) {
        doc.setFontSize(14);
        // doc.setFont("Roboto-Bold", "bold", "bold");
        doc.text(this.props.divisionsObject[key].name, 10, 10);
        extraY = 10;
      }
      doc.setFontSize(12);
      doc.setFont("Roboto-Medium", "normal", "normal");
      doc.text(languages.results.rank, 10, 10 + extraY);
      if (showPresent) {
        doc.text(languages.teams.present, 23, 10 + extraY);
      }
      doc.text(languages.results.team, teamNameX, 10 + extraY);
      doc.text(languages.results.standing, finalPositionX, 10 + extraY);
      doc.text(languages.results.pouleResults.points, pointsX, 10 + extraY);
      if (this.props.useSets) {
        doc.text(languages.results.pouleResults.setsFor, 115, 10 + extraY);
        doc.text(languages.results.pouleResults.setsAgainst, 130, 10 + extraY);
        doc.text(
          languages.results.pouleResults.setsDifference,
          145,
          10 + extraY
        );
      }
      doc.text(languages.results.pouleResults.goalsFor, 160, 10 + extraY);
      doc.text(languages.results.pouleResults.goalsAgainst, 175, 10 + extraY);
      doc.text(languages.results.pouleResults.goals, 190, 10 + extraY);
      let divisionRanking = this.props.ranking[key];
      divisionRanking.forEach((ranking, x) => {
        if (extraY > 270) {
          doc.addPage();

          extraY = 0;
          if (Object.keys(this.props.ranking).length > 1) {
            doc.setFontSize(14);
            // doc.setFont("Roboto-Bold", "bold", "bold");
            doc.text(this.props.divisionsObject[key].name, 10, 10);
            extraY = 10;
          }
          doc.setFontSize(12);
          doc.setFont("Roboto-Medium", "normal", "normal");
          doc.text(languages.results.rank, 10, 10 + extraY);
          if (showPresent) {
            doc.text(languages.teams.present, 23, 10 + extraY);
          }
          doc.text(languages.results.team, teamNameX, 10 + extraY);
          doc.text(languages.results.standing, finalPositionX, 10 + extraY);
          doc.text(languages.results.pouleResults.points, pointsX, 10 + extraY);
          if (this.props.useSets) {
            doc.text(languages.results.pouleResults.setsFor, 115, 10 + extraY);
            doc.text(
              languages.results.pouleResults.setsAgainst,
              130,
              10 + extraY
            );
            doc.text(
              languages.results.pouleResults.setsDifference,
              145,
              10 + extraY
            );
          }
          doc.text(languages.results.pouleResults.goalsFor, 160, 10 + extraY);
          doc.text(
            languages.results.pouleResults.goalsAgainst,
            175,
            10 + extraY
          );
          doc.text(languages.results.pouleResults.goals, 190, 10 + extraY);
        }
        extraY += 6;
        doc.text(
          !ranking.hideRank ? (x + 1).toString() + "." : "",
          10,
          10 + extraY
        );
        let teamName = ranking.team.name;
        if (teamName.length > maxTextLength) {
          teamName =
            teamName.slice(0, maxTextLength - 8) +
            "..." +
            teamName.slice(teamName.length - 5);
        }
        if (showPresent) {
          if (ranking.team.present) {
            doc.text("x", 23, 10 + extraY);
          }
        }
        doc.text(teamName, teamNameX, 10 + extraY);

        let fromPouleName = ranking.fromPouleName;
        if (fromPouleName.length > maxTextLength) {
          fromPouleName =
            fromPouleName.slice(0, maxTextLength - 8) +
            "..." +
            fromPouleName.slice(fromPouleName.length - 5);
        }
        doc.text(fromPouleName, finalPositionX, 10 + extraY);
        doc.text(
          !ranking.isBracket ? ranking.pouleScore.toString() : "",
          pointsX,
          10 + extraY
        );
        if (this.props.useSets) {
          doc.text(
            !ranking.isBracket ? ranking.setsFor.toString() : "",
            115,
            10 + extraY
          );
          doc.text(
            !ranking.isBracket ? ranking.setsAgainst.toString() : "",
            130,
            10 + extraY
          );
          doc.text(
            !ranking.isBracket ? ranking.sets.toString() : "",
            145,
            10 + extraY
          );
        }
        doc.text(
          !ranking.isBracket ? ranking.goalsFor.toString() : "",
          160,
          10 + extraY
        );
        doc.text(
          !ranking.isBracket ? ranking.goalsAgainst.toString() : "",
          175,
          10 + extraY
        );
        doc.text(
          !ranking.isBracket ? ranking.goals.toString() : "",
          190,
          10 + extraY
        );
      });
    });

    // let extraY = 0;
    // if (dayString) {
    //   extraY = 6;
    //   doc.setFontSize(13);
    //   doc.text(dayString, 5, 10);
    // }
    // doc.setFontSize(14);
    // doc.setFontStyle("bold");
    // doc.text(fieldString, 5, 10 + extraY);
    // doc.text(timeString, 5 + 69 + 101, 10 + extraY);
    // doc.setFontStyle("normal");
    // doc.setFontSize(13);
    // doc.text(pouleString, 5, 18 + extraY);
    // doc.text(divisionString, 5, 23 + extraY);
    // if (refereeString) {
    //   doc.addImage(datauri, "PNG", 5, 27 + extraY, 4, 4);
    //   doc.text(refereeString, 10, 31 + extraY);
    //   extraY += 6;
    // }
    // doc.text(doc.splitTextToSize(team1String, 80), 5, 35 + extraY);
    // doc.text(doc.splitTextToSize(team2String, 80), 52 + 52, 35 + extraY);
    // doc.setLineWidth(0.1);
    // doc.setDrawColor(171, 171, 171);
    // doc.line(5 + 45 + 52, 30 + extraY, 5 + 45 + 52, 260 + extraY);
    // doc.line(5, 30 + extraY, 5 + 95 + 105, 30 + extraY);

    doc.save(languages.results.ranking + ".pdf");
  };

  render() {
    return (
      <div>
        <Button
          size="small"
          variant="outlined"
          color="default"
          onClick={this.handleExport}
          // style={{ position: "absolute", top: 20, right: 25 }}
        >
          {languages.export.exportPDF}
          <DownloadIcon
            style={{
              height: 16,
              width: 16,
              transform: "scaleX(-1)",
              marginLeft: 10,
            }}
          />
        </Button>
      </div>
    );
  }
}

export default ExportRankingContainer;
